import React from 'react';
import { Field, useField, useForm } from 'react-final-form';

import { detailsForceSavedMethods } from '../../../../utils/cashier';
import Checkbox from '../../../Checkbox/Checkbox';
import type { Props } from '../../SavePaymentInfo';
import { fastDepositField, saveCardField } from '../../SavePaymentInfo';

import {
  TXTWCL_Make_this_my_preferred_payment_ELL,
  TXTWCL_Save_payment_method_details
} from './ReloaderCheckboxes.messages.json';

const ReloaderCheckboxes: React.FC<Props> = ({ type }) => {
  const form = useForm();

  const forceSavePaymentMethod = detailsForceSavedMethods(type);

  const {
    input: { value: savedCheckboxValue }
  } = useField(saveCardField, {
    initialValue: forceSavePaymentMethod,
    subscription: { value: true }
  });

  const {
    input: { value: fastDepositCheckboxValue }
  } = useField(fastDepositField, { subscription: { value: true } });

  return (
    <>
      {!forceSavePaymentMethod && (
        <Field name={saveCardField} type="checkbox">
          {({ input: { onChange, checked } }) => (
            <Checkbox
              name={saveCardField}
              checked={checked}
              onChange={(event) => {
                !fastDepositCheckboxValue && onChange(event);
              }}
              label={TXTWCL_Save_payment_method_details}
              disabled={!!fastDepositCheckboxValue}
            />
          )}
        </Field>
      )}

      <Field name={fastDepositField} type="checkbox">
        {({ input: { onChange, checked } }) => (
          <Checkbox
            name={fastDepositField}
            checked={checked}
            onChange={(event) => {
              onChange(event);
              !checked &&
                !savedCheckboxValue &&
                !forceSavePaymentMethod &&
                form.change(saveCardField, true);
            }}
            label={TXTWCL_Make_this_my_preferred_payment_ELL}
          />
        )}
      </Field>
    </>
  );
};

export default ReloaderCheckboxes;
